import { parseISO, startOfDay } from 'date-fns';
import { Campaign, getBannerIdFromMatch, getCampaignIdFromMatch } from 'utils/campaign';
import { ADMINS } from 'utils/constants/user';

import { Requirements } from 'app/routes';

import { Action } from 'store/createReducer';
import { Banner } from 'store/models/dashboard';
import {
    setStatisticsBannerId,
    setStatisticsCampaignId,
    setStatisticsDates,
    setStatisticsObjectName,
    setStatisticsShowCr,
    setStatisticsVacancyId,
} from 'store/models/statistics';
import { User, UserType } from 'store/models/user';

const StatisticRequirements: Requirements<{
    banner: Banner & { user?: User; actualUser?: User };
    campaign: Campaign;
}> = {
    methods: ({ match }) => {
        const bannerId = getBannerIdFromMatch(match);
        const campaignId = getCampaignIdFromMatch(match);

        return {
            ...(bannerId && { banner: { url: `/api/v1/banners/${bannerId}`, cacheable: false } }),
            ...(campaignId && { campaign: { url: `/api/v1/campaigns/${campaignId}`, cacheable: false } }),
        };
    },
    resolve: ({ result: { banner, campaign = banner }, state: { statistics }, match }) => {
        const object = banner ?? campaign;
        const bannerId = getBannerIdFromMatch(match);
        const campaignId = getCampaignIdFromMatch(match);
        const showCr =
            ADMINS.includes(banner?.user?.userType as UserType) ||
            ADMINS.includes(banner?.actualUser?.userType as UserType);
        const pageActions: Action[] = [
            setStatisticsBannerId(bannerId ?? 0),
            setStatisticsCampaignId(campaignId ?? 0),
            setStatisticsObjectName(object.title),
            setStatisticsShowCr(showCr),
        ];
        if (object.createdAt) {
            pageActions.push(setStatisticsDates({ from: startOfDay(parseISO(object.createdAt)), to: statistics.to }));
        }
        if (object.vacancyId) {
            pageActions.push(setStatisticsVacancyId(object.vacancyId));
        }
        return pageActions;
    },
};

export default StatisticRequirements;
